import * as React from 'react';
import { HeaderFilterTable, Icon } from '@/components/common';
import { Options } from '@/components/ui/combobox';
import Icons from '@/const/icons';
import { GET_CLEANUP_WIZARD_STATUS_FILTER } from '@/api';
import { useQuery } from '@tanstack/react-query';
import { useFilters } from '@/hooks';
import { cleanupWizardService } from '@/api/cleanupWizard';
import { StatusCleanupWizard } from '@/interfaces';

export const StatusFilter = () => {
	const FILTER_KEY = 'status';
	const { setParamFilter, hasFilter } = useFilters();
	const [data, setData] = React.useState<Options[]>([]);

	const { data: reasonFilterList } = useQuery({
		queryKey: [GET_CLEANUP_WIZARD_STATUS_FILTER],
		queryFn: () => cleanupWizardService.getStatusFilter(),
	});

	const getIcon = (status: StatusCleanupWizard) => {
		const icons: Record<StatusCleanupWizard, string> = {
			'Contact Customer': Icons.messages,
			'Deactivate Account': Icons.profileDelete,
			'Review Required': Icons.search,
		};
		return icons[status];
	};

	React.useEffect(() => {
		if (reasonFilterList) {
			const auxList: Options[] = [];
			reasonFilterList.data.map((item) =>
				auxList.push({
					label: item,
					value: item,
					icon: (
						<Icon
							src={getIcon(item) || ''}
							width={18}
							height={18}
							className="text-primary"
						/>
					),
				})
			);
			setData(auxList);
		}
	}, [reasonFilterList]);

	const handleSelectFilters = (value?: string) => {
		setParamFilter(FILTER_KEY, value);
	};

	const handleClearAll = () => {
		setParamFilter(FILTER_KEY, '');
	};

	return (
		<HeaderFilterTable
			title="Status"
			searchTitle="Filter by status"
			filterOptions={data}
			classNamePopoverContent="lg:!w-[242px]"
			handleClearAll={handleClearAll}
			handleSelectFilters={handleSelectFilters}
			hasFilter={hasFilter(FILTER_KEY)}
		/>
	);
};
